<template>
	<div>
		<!-- <FunctionTitle :title="mainTitle" /> -->
		<CommonFlame :title="subTitle">
			<div class="d-flex overflow">
				<div class="boxes height" v-if="authorityFlag">
					<div class="boxes__box">
						<h2>{{ department_name }}所属社員</h2>
						<div class="boxes__scroll">
							<draggable
								:group="{ name: 'items', pull: 'clone', put: false }"
								@end="createRequirementUsers"
							>
								<v-card
									elevation="2"
									v-for="(department_user, index) in department_users"
									:key="index"
									:id="`text${department_user.id}`"
									class="my-2"
								>
									<v-list-item>
										<v-list-item-content>
											<v-list-item-title>
												{{ department_user.full_name }}
											</v-list-item-title>
										</v-list-item-content>
									</v-list-item>
								</v-card>
							</draggable>
						</div>
					</div>
				</div>
				<div class="grow ml-2">
					<h6 class="text-h6" v-if="!authorityFlag">依頼振り分け権限がありません。</h6>
					<v-row no-gutters class="minw250px max450px">
						<v-combobox
							label="依頼の種類を絞り込む"
							v-model="selectedRequirementType"
							:items="requirementTypes"
							item-text="name"
							item-value="id"
							no-data-text=""
							class="mt-4"
							outlined
							dense
							clearable
							hide-details=""
							@change="fetchRequirements($route.query.page ? $route.query.page : 1)"
						/>
					</v-row>
					<div class="table-container mt-4">
						<v-data-table
							locale="ja-JP"
							:headers="headers"
							:items="requirements"
							:mobile-breakpoint="240"
							hide-default-footer
							disable-filtering
							disable-pagination
							disable-sort
							no-data-text="データがありません。"
						>
							<template v-slot:item="{ item }">
								<tr>
									<draggable
										:class="`text${item.id}`"
										:group="{ name: 'items', pull: true }"
										tag="td"
										handle=".handle"
										><v-btn
											v-if="item.responder.full_name && authorityFlag"
											@click="deleteRequirementUser(item.id)"
											icon
											><v-icon>mdi-close</v-icon></v-btn
										>
										{{ item.responder.full_name }}
									</draggable>
									<td class="px-1" @click="showDialog(item.id, 1)">
										{{ item.requirement_type.name }}
										<br v-if="item.subtitle" />
										{{ item.subtitle }}
									</td>
									<td class="px-1" @click="showDialog(item.id, 1)">{{ item.status_id_i18n }}</td>
									<td class="px-1" @click="showDialog(item.id, 1)">
										{{
											$store.getters.department(item.from_department_id) != null
												? $store.getters.department(item.from_department_id).name
												: ""
										}}
									</td>
									<td class="px-1" @click="showDialog(item.id, 1)">{{ item.user.full_name }}</td>
									<td class="px-1" @click="showDialog(item.id, 1)">
										{{
											$store.getters.department(item.to_department_id) != null
												? $store.getters.department(item.to_department_id).name
												: ""
										}}
									</td>
									<td class="px-1" @click="showDialog(item.id, 1)">
										{{ common.formatDate(item.deadline) }}
									</td>
									<td class="px-1" @click="showDialog(item.id, 1)">
										<span v-if="item.matter">{{ item.matter.name }}</span>
									</td>
								</tr>
							</template>
						</v-data-table>
					</div>
					<PaginationModule :pagination="pagination" @get-page="getPage($event)"></PaginationModule>
				</div>
			</div>
		</CommonFlame>
		<RequirementShowDialog
			ref="show"
			:hideAnswer="true"
			@reloadIndex="reloadList"
			@update-requirement="updateRequirement($event)"
		/>
	</div>
</template>

<script>
import draggable from "vuedraggable"
import axios from "axios"
import common from "../../helper/common"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import FunctionTitle from "../shared/FunctionTitle.vue"
import CommonFlame from "../shared/CommonFlame.vue"
import PaginationModule from "../../modules/PaginationModule.vue"
import RequirementShowDialog from "../requirement/components/RequirementInfoDialog.vue"

export default {
	components: {
		draggable,
		FunctionTitle,
		CommonFlame,
		PaginationModule,
		RequirementShowDialog,
	},
	data() {
		return {
			user: {},
			userList: [],
			requirementTypes: [],
			typesForSearch: [],
			statusIdsHash: {},
			id: this.$route.params["id"],
			department_users: [],
			department_name: "",
			requirements: [],
			responder: [],
			subTitle: "依頼担当変更",
			mainTitle: "依頼担当変更",
			authorityFlag: false,
			selectedRequirementType: null,
			pagination: {
				count: null,
				current: 1,
				limit_value: null,
				next: null,
				pages: null,
				previous: null,
			},
			headers: [
				{ class: "px-1", text: "担当者", value: "", width: "225px" },
				{ class: "px-1", text: "依頼の種類", value: "requirement_type_name", width: "225px" },
				{ class: "px-1", text: "状態", value: "", width: "100px" },
				{ class: "px-1", text: "依頼元部門", value: "from_department_name", width: "100px" },
				{ class: "px-1", text: "依頼者", value: "user_name", width: "100px" },
				{ class: "px-1", text: "依頼先部門", value: "to_department_name", width: "100px" },
				{ class: "px-1", text: "依頼納期", value: "deadline", width: "100px" },
				{ class: "px-1", text: "案件", value: "matter_name", width: "100px" },
			],
			common,
		}
	},

	created() {
		const page = this.$route.query.page ? this.$route.query.page : 1
		this.fetchRequirements(page)
	},

	methods: {
		fetchRequirements(page) {
			this.requirements = []
			authenticate.authenticateUser()
			const headers = authenticate.setHeader()
			axios
				.get(`/erp/v1/departments/${this.id}/requirement_users`, {
					params: {
						page: page,
						responder_present: true,
						selected_requirement_type_id: this.selectedRequirementType
							? this.selectedRequirementType.id
							: "",
					},
					headers,
				})
				.then((res) => {
					this.department_users = res.data.department_users
					this.pagination = res.data.pagination
					this.department_name = res.data.department.name
					this.requirements = res.data.requirements
					this.requirementTypes = res.data.requirement_types
					this.responder = res.data.requirements.responder_id
					this.statusIdsHash = res.data.status_ids_hash
					this.authorityFlag = res.data.authority_flag
					console.log(this.requirements)
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		getPage(page) {
			this.fetchRequirements(page)
		},

		createRequirementUsers(e) {
			const headers = authenticate.setHeader()

			const check = e.item.id
			const responder_id = check.split("text").join("")

			const target = e.to.className
			const requirement_id = target.split("text").join("")
			if (!requirement_id) return
			axios
				.put(
					`/erp/v1/departments/${this.id}/requirement_users/${requirement_id}`,
					{ requirement_user: { responder_id } },
					{ headers }
				)
				.then((res) => {
					const requirement_responder = res.data
					let requirement = this.requirements.find((r) => r.id == requirement_id)
					const index = this.requirements.indexOf(requirement)
					console.log(requirement_responder)
					requirement["responder"] = requirement_responder
					this.requirements[index] = requirement
					console.log(this.requirements[index])
					e.to.getElementsByClassName("v-card")[0].remove()
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},

		deleteRequirementUser(id) {
			const headers = authenticate.setHeader()

			axios
				.delete(`/erp/v1/departments/${this.id}/requirement_users/${id}`, { headers })
				.then((res) => {
					this.$store.dispatch("setFlash", {
						text: "削除しました",
						type: "notice",
					})
					let requirement = this.requirements.find((r) => r.id == id)
					const index = this.requirements.indexOf(requirement)
					requirement.responder = { full_name: null }
					this.requirements[index] = requirement
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		reloadList() {
			const page = this.$route.query.page ? this.$route.query.page : 1
			this.fetchRequirements(page)
		},
		showDialog(id, index) {
			this.$refs.show.openDialog(id, index)
		},
		setSearchedList(requirements) {
			this.searchedFlag = true
			this.requirements = requirements
		},
		updateRequirement(requirement) {
			const oldRequirement = this.requirements.find((r) => r.id == requirement.id)
			const index = this.requirements.indexOf(oldRequirement)
			this.$set(this.requirements, index, requirement)
		},
	},
}
</script>

<style lang="scss" scoped>
.boxes {
	min-width: 250px;
	&__box {
		padding: 8px;
		text-align: center;
	}
	&__scroll {
		margin-top: 8px;
	}
}

.height {
	height: calc(100vh - 200px);
	overflow-y: scroll;
}

td {
	height: 50px !important;
}

.overflow {
	overflow-x: scroll;
}

.v-card {
	cursor: pointer;
}
</style>
